import { LeftMenu, PathRestoration } from "@@components";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useContext, useMemo } from "react";
import { Outlet, useMatches } from "react-router-dom";
import BundleContext from "../UserInterfaceModule/Contexts/BundleContext";

export default function MainLayout() {
  const bundle = useContext(BundleContext);
  const matches = useMatches();

  const showLeftMenu = useMemo(() => {
    // Find the deepest matched route that corresponds to a known view
    const matchedView = [...matches]
      .reverse()
      .map((match) => bundle.ViewById[match.id])
      .find((view) => view !== undefined && !view.Dialog);

    // Hide the left menu only when the matched view explicitly sets Menu.Visible to false
    return matchedView?.Menu?.Visible !== false;
  }, [matches, bundle.ViewById]);

  return (
    <Stack direction="row" sx={{ overflow: "hidden" }}>
      <PathRestoration />
      {showLeftMenu && <LeftMenu />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          minWidth: 0,
          overflow: "auto",
          backgroundColor: "background.default",
        }}
      >
        <Outlet />
      </Box>
    </Stack>
  );
}
